<template>
  <div class="webStack-wrap">
    <div class="webStack-side-wrap">
      <SideMenu
        :sideOpen="sideOpen"
        @sideMenuClick="handlerSideClick"></SideMenu>
    </div>
    <div class="webStack-body-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import SideMenu from './components/sideMenu/sideMenu.vue'

export default {
  data() {
    return {
    }
  },
  components: {
    SideMenu
  },
  created() {
      const { meta } = this.$route
      this.sideOpen = meta.title.split(',')
  },
  methods: {
    handlerSideClick(params) {
      const { name, meta } = params
      this.metaTitle = meta
      this.$router.push({ name })
    }
  }
}
</script>